import { AuthConfig } from 'authen-service-library';
import { environment } from '../environment';

// export const authCodeFlowConfig: Partial<any> = {
//   issuer: 'https://id-test.trueconnect.vn',
//   clientId: 'localhost_identity_short',
//   tokenEndpoint: environment.API_URL + '/connect/token',
//   userinfoEndpoint: environment.API_URL + '/connect/userinfo',
//   responseType: 'code',
//   silentRefreshRedirectUri: 'http://localhost:4200',
//   redirectUri: 'http://localhost:4200',
//   dummyClientSecret: 'no_important',
//   scope: 'offline_access roles profile openid email',
//   // customQueryParams: {
//   //   grant_type: 'refresh_token',
//   // },
//   // useSilentRefresh: true,
//   // Enables session checks
//   // showDebugInformation: true,
//   oidc: false,
//   clearHashAfterLogin: false,
//   useIdTokenHintForSilentRefresh: true,
// };

export const authCodeFlowConfig: Partial<any> = {
  issuer: environment.API_URL + '/',
  tokenEndpoint: environment.API_URL + '/connect/token',
  userinfoEndpoint: environment.API_URL + '/connect/userinfo',
  silentRefreshRedirectUri: window.location.origin,
  // redirectUri: window.location.origin,
  clientId: 'pm',
  responseType: 'code',
  dummyClientSecret: '$,Zf.EXS@quyb}DYC8{@i]P{!?*J=k',
  scope: 'offline_access roles profile openid email',
  // customQueryParams: {
  //   grant_type: 'refresh_token',
  // },
  useSilentRefresh: true,
  // silentRefreshTimeout: 50000, // Timeout for silent refresh
  // sessionChecksEnabled: true, // Enables session checks
  // showDebugInformation: true,
  oidc: false,
  clearHashAfterLogin: false,
  useIdTokenHintForSilentRefresh: true,
};

export const authNoOIDC: AuthConfig = {
  loginURl: environment.API_URL + '/users/login',
  refreshTokenURL: environment.API_URL + '/users/refresh-token',
  logoutURL: environment.API_URL + '/users/logout',
};
